import BaseService from "../BaseService";

export default class KontingentMonitoringService extends BaseService {

  constructor() {
    super('monitoring/kontingent');
  }
}
